import gql from 'graphql-tag'

export default gql`
  mutation PriceUpdateMutation($id: ID!, $name: String!, $conversions: [PriceConversionInput!]!) {
    priceUpdate(id: $id, name: $name, conversions: $conversions) {
      id
    }
  }
`
